<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="min-h-screen">
    <div class="bg-[#0A2815] text-white py-12 md:py-20 relative overflow-hidden">
      <div
        class="absolute inset-0 bg-[url('https://ai-public.mastergo.com/ai/img_res/74bd02650e8e0db78a9ad3cc092f5792.jpg')] bg-cover bg-center opacity-10"
      ></div>
      <div class="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div class="flex flex-col lg:flex-row gap-8 md:gap-12 items-start">
          <div class="flex-1">
            <h1 class="text-xl md:text-3xl lg:text-4xl font-bold mb-4 md:mb-6 leading-tight tracking-tight">
              {{ t('contact.title') }} <span class="text-[#4CAF50]">.</span>
            </h1>
            <p class="text-sm md:text-base mb-6 md:mb-8 max-w-2xl leading-relaxed text-white/90">
              {{ t('contact.subtitle') }}
            </p>
            <p class="text-xs md:text-sm mb-6 md:mb-8 max-w-2xl leading-relaxed text-white/80">
              {{ t('contact.description') }}
            </p>
            <div class="space-y-4 md:space-y-6">
              <div
                class="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-white/5 rounded-xl backdrop-blur-sm hover:bg-white/10 transition-all duration-300"
              >
                <environment-outlined class="text-xl md:text-2xl mt-1 text-[#4CAF50] flex-shrink-0" />
                <div class="min-w-0 flex-1">
                  <h3 class="font-medium mb-1 text-xs md:text-sm">{{ t('contact.contactInfo.address.label') }}</h3>
                  <p class="text-white/80 text-xs md:text-sm break-words">
                    {{ t('contact.contactInfo.address.value') }}
                  </p>
                </div>
              </div>
              <div
                class="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-white/5 rounded-xl backdrop-blur-sm hover:bg-white/10 transition-all duration-300"
              >
                <phone-outlined class="text-xl md:text-2xl mt-1 text-[#4CAF50] flex-shrink-0" />
                <div class="min-w-0 flex-1">
                  <h3 class="font-medium mb-1 text-xs md:text-sm">{{ t('contact.contactInfo.phone.label') }}</h3>
                  <p class="text-white/80 text-xs md:text-sm break-all">{{ t('contact.contactInfo.phone.value') }}</p>
                </div>
              </div>
              <div
                class="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-white/5 rounded-xl backdrop-blur-sm hover:bg-white/10 transition-all duration-300"
              >
                <mail-outlined class="text-xl md:text-2xl mt-1 text-[#4CAF50] flex-shrink-0" />
                <div class="min-w-0 flex-1">
                  <h3 class="font-medium mb-1 text-xs md:text-sm">{{ t('contact.contactInfo.email.label') }}</h3>
                  <p class="text-white/80 text-xs md:text-sm break-all">{{ t('contact.contactInfo.email.value') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden lg:block flex-1">
            <div
              class="relative h-full min-h-[300px] rounded-2xl overflow-hidden"
            >
              <div
                class="absolute inset-0 bg-gradient-to-r from-[#0A2815]/80 to-transparent z-10"
              ></div>
              <div
                class="absolute inset-0 bg-[url('https://ai-public.mastergo.com/ai/img_res/0f8772dccb905c468eb7ae12f615e21f.jpg')] bg-cover bg-center"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-16">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16">
        <div class="relative overflow-hidden rounded-2xl shadow-xl min-h-[300px] md:min-h-[400px]">
          <div
            class="absolute inset-0 bg-gradient-to-r from-[#0A2815]/80 to-transparent z-10"
          ></div>
          <div
            :class="`absolute inset-0 bg-cover bg-center`"
            :style="{ backgroundImage: `url(${backgroundImg})` }"
          ></div>
          <div class="relative z-20 h-full flex flex-col justify-end p-6 md:p-12">
            <h3 class="text-white text-base md:text-xl font-medium mb-2">{{ t('contact.contactInfo.office.label') }}</h3>
            <p class="text-white/80 max-w-md text-xs md:text-sm">
              {{ t('contact.contactInfo.office.value') }}
            </p>
          </div>
        </div>
        <div class="bg-white rounded-2xl shadow-xl p-6 md:p-12">
          <h2 class="text-base md:text-xl font-semibold mb-6 md:mb-8 text-gray-800">
            {{ t('contact.form.title') }}
          </h2>
          <form class="space-y-4 md:space-y-6" @submit.prevent="handleSubmit">
            <div>
              <label class="block text-xs font-medium mb-2 text-gray-600">
                {{ t('contact.form.name.label') }}
              </label>
              <a-input
                v-model:value="formData.name"
                :placeholder="t('contact.form.name.placeholder')"
                size="large"
                class="border-gray-200 hover:border-[#4CAF50] focus:border-[#4CAF50]"
              >
                <template #prefix>
                  <user-outlined class="text-gray-400" />
                </template>
              </a-input>
            </div>
            <div>
              <label class="block text-xs font-medium mb-2 text-gray-600">
                {{ t('contact.form.email.label') }}
              </label>
              <a-input
                v-model:value="formData.email"
                :placeholder="t('contact.form.email.placeholder')"
                size="large"
                class="border-gray-200 hover:border-[#4CAF50] focus:border-[#4CAF50]"
              >
                <template #prefix>
                  <mail-outlined class="text-gray-400" />
                </template>
              </a-input>
            </div>
            <div>
              <label class="block text-xs font-medium mb-2 text-gray-600">
                {{ t('contact.form.phone.label') }}
              </label>
              <a-input
                v-model:value="formData.phone"
                :placeholder="t('contact.form.phone.placeholder')"
                size="large"
                class="border-gray-200 hover:border-[#4CAF50] focus:border-[#4CAF50]"
              >
                <template #prefix>
                  <phone-outlined class="text-gray-400" />
                </template>
              </a-input>
            </div>
            <div>
              <label class="block text-xs font-medium mb-2 text-gray-600">
                {{ t('contact.form.message.label') }}
              </label>
              <a-textarea
                v-model:value="formData.message"
                :placeholder="t('contact.form.message.placeholder')"
                :rows="4"
                class="border-gray-200 hover:border-[#4CAF50] focus:border-[#4CAF50]"
              />
            </div>
            <a-button
              type="primary"
              html-type="submit"
              :loading="isSubmitting"
              class="!rounded-button whitespace-nowrap bg-[#4CAF50] hover:bg-[#45a049] w-full h-12 md:h-14 text-xs md:text-sm font-medium shadow-md"
              size="large"
            >
              {{ isSubmitting ? t('contact.form.sending') : t('contact.form.submit') }}
            </a-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import {
    EnvironmentOutlined,
    PhoneOutlined,
    MailOutlined,
    UserOutlined
  } from '@ant-design/icons-vue'
  
  // 使用相对路径导入背景图片
  const backgroundImg = new URL('@/assets/contact/jimeng-2025-08-26-1132-生成一个新厂房，有工厂大门，背后厂房高楼楼，周边有绿化，整体环境新.png', import.meta.url).href

  const { t } = useI18n()

  const formData = ref({
    name: '',
    email: '',
    phone: '',
    message: ''
  })

  const isSubmitting = ref(false)

  const handleSubmit = async () => {
    try {
      isSubmitting.value = true
      // 表单提交逻辑
      console.log('提交表单数据:', formData.value)
      // 这里可以添加实际的API调用
      
      // 模拟提交延迟
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      // 重置表单
      formData.value = {
        name: '',
        email: '',
        phone: '',
        message: ''
      }
      
      // 可以添加成功提示
      console.log(t('contact.form.success'))
    } catch (error) {
      console.error('提交失败:', error)
      // 可以添加错误提示
      console.log(t('contact.form.error'))
    } finally {
      isSubmitting.value = false
    }
  }
</script>
<style scoped>
  :deep(.ant-input),
  :deep(.ant-input-affix-wrapper),
  :deep(.ant-input-textarea) {
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-family: 'Inter', sans-serif;
  }
  :deep(.ant-input:hover),
  :deep(.ant-input-affix-wrapper:hover),
  :deep(.ant-input-textarea:hover) {
    border-color: #4caf50;
    transform: translateY(-1px);
  }
  :deep(.ant-input:focus),
  :deep(.ant-input-affix-wrapper-focused),
  :deep(.ant-input-textarea:focus) {
    border-color: #4caf50;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.15);
    transform: translateY(-2px);
  }
  :deep(.ant-btn-primary) {
    border: none;
    height: 56px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  :deep(.ant-btn-primary:hover) {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(76, 175, 80, 0.25);
  }
  :deep(.ant-input-lg) {
    padding: 16px 20px;
    font-size: 16px;
  }
  :deep(.ant-input-prefix) {
    margin-right: 12px;
  }
</style>
